import { render, staticRenderFns } from "./MailTemplatesPanel.vue?vue&type=template&id=50b2e38a&scoped=true"
import script from "./MailTemplatesPanel.vue?vue&type=script&lang=js"
export * from "./MailTemplatesPanel.vue?vue&type=script&lang=js"
import style0 from "./MailTemplatesPanel.vue?vue&type=style&index=0&id=50b2e38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b2e38a",
  null
  
)

export default component.exports